module.exports = __webpack_public_path__ + "static/media/neu_logo.70127162.png";